import { FIELD_TYPES } from "./fieldTypes";

export const FILTER_FIELDS = {
  brandId: FIELD_TYPES.integer,
  contractTermInMonths: FIELD_TYPES.integer,
  dataSpeedGen: FIELD_TYPES.integer,
  inStock: FIELD_TYPES.boolean,
  isIndependent: FIELD_TYPES.boolean,
  isRetention: FIELD_TYPES.boolean,
  limit: FIELD_TYPES.integer,
  maxMonthlyFee: FIELD_TYPES.integer,
  maxPrice: FIELD_TYPES.integer,
  minDataCredits: FIELD_TYPES.integer,
  minDataSpeedDown: FIELD_TYPES.integer,
  minSmsCredits: FIELD_TYPES.integer,
  minVoiceCredits: FIELD_TYPES.integer,
  offerExtraId: FIELD_TYPES.integer,
  phoneCategoryId: FIELD_TYPES.integer,
  phoneId: FIELD_TYPES.integer,
  phoneOperatingSystemId: FIELD_TYPES.integer,
  phoneVariantId: FIELD_TYPES.integer,
  providerId: FIELD_TYPES.integer,
  shopId: FIELD_TYPES.integer
};
